import styled from '@emotion/styled';
import { TextField, FormControl } from '@mui/material';
import Grid from '@mui/material/Grid';

import OptionalAccountFields from 'account/components/CreateAccountModal/OptionalAccountFields';
import TierSelectField from 'account/components/CreateAccountModal/TierSelectField';

/*
  Step 2 of the billed-account flow (BT-9485). After the user picks an unmatched
  Recurly account, they review/complete its details before the account is created:
    - Account name  — editable, prefilled from the Recurly account name.
    - Billing code  — read-only (the chosen Recurly account code).
    - HubSpot Record ID + Internal Email Domains — see OptionalAccountFields.

  HubSpot ids and Recurly account codes are the same numeric id for accounts created
  the modern way, so we prefill HubSpot from the billing code — but ONLY when the code
  is purely numeric. Legacy/suffixed codes (e.g. 310493960950CAA) would fail the
  digits-only (bigint) backend validation, so they are left blank for CS to fill.
*/

const GridContainer = styled(Grid)`
  margin-bottom: 16px;
`;

const FieldLabel = styled(Grid)`
  font-weight: bold;
  font-size: 14px;
`;

const ReadOnlyValue = styled.div`
  font-size: 14px;
  padding: 4px 0;
`;

function BilledAccountDetails({ account = {}, billingCode = '' }) {
  const defaultHubspotRecordId = /^\d+$/.test(billingCode) ? billingCode : '';

  return (
    <>
      <GridContainer item xs={12} md={6}>
        <FormControl fullWidth>
          <Grid container alignItems="center" spacing={2}>
            <FieldLabel item xs={12} sm={3}>Account name:</FieldLabel>
            <Grid item xs={12} sm={6}>
              <TextField
                name="account_name"
                fullWidth
                size="small"
                type="text"
                required
                defaultValue={account.account_name || ''}
              />
            </Grid>
          </Grid>
        </FormControl>
      </GridContainer>
      <GridContainer item xs={12} md={6}>
        <Grid container alignItems="center" spacing={2}>
          <FieldLabel item xs={12} sm={3}>Billing code:</FieldLabel>
          <Grid item xs={12} sm={6}>
            <ReadOnlyValue>{billingCode}</ReadOnlyValue>
          </Grid>
        </Grid>
      </GridContainer>
      <TierSelectField />
      <OptionalAccountFields defaultHubspotRecordId={defaultHubspotRecordId} />
    </>
  );
}

export default BilledAccountDetails;
